module.exports = __webpack_public_path__ + "img/file-audio.0d3624d4.svg";